import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { AppNotifications, RootState, QuotationOptionService } from "../../../../models";
import { QuotationService } from "../../../../services";
import { NotificationActions } from "../../../../store/actions";
import QuotationFormPresenter from "./QuotationForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./QuotationForm.type";
import { loadCallback } from "../../../../utils";
import { withRouter } from "react-router-dom";
import _ from "lodash";

class QuotationFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      initData: this.props.initial || null,
    };
  }

  onSubmit = (val: any) => {
    let data: any = {
      ...val,
      service: this.props.shipmentService,
    };
    data = _.pickBy(data, (v) => !_.isUndefined(v));

    if (data.service === QuotationOptionService.FREIGHTFORWARDING) {
      this.onCreateFreightForwarding(data);
    }
    else if (data.service === QuotationOptionService.ECOMMERCE) {
      this.onCreateEcommerceFulfillment(data);
    }
  };

  onCreateFreightForwarding = (data) => {
    QuotationService.createFreightForwarding(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create quotation success",
          });
          loadCallback(this.props.onComplete_Create);
        } else if (res) {
          if (res.status === 409) {
            if (res.data?.message === "EMAIL_EXISTED") {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Email existed" });
            } else if (res.data?.message === "PHONE_EXISTED") {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Phone number existed" });
            } else {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create quotation failed" });
            }
          }
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create quotation failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create quotation failed" });
      });
  };

  onCreateEcommerceFulfillment = (data) => {
    QuotationService.createEcommerceFulfillment(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create quotaion success",
          });
          loadCallback(this.props.onComplete_Create);
        } else if (res) {
          if (res.status === 409) {
            if (res.data?.message === "EMAIL_EXISTED") {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Email existed" });
            } else if (res.data?.message === "PHONE_EXISTED") {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Phone number existed" });
            } else {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create quotation failed" });
            }
          }
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create quotation failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create quotation failed" });
      });
  };

  render() {
    return (
      <QuotationFormPresenter
        {...this.props}
        {...this.state}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(QuotationFormContainer)
);
